import { render, staticRenderFns } from "./AiChat.vue?vue&type=template&id=5d57aa0d&scoped=true&"
import script from "./AiChat.vue?vue&type=script&lang=js&"
export * from "./AiChat.vue?vue&type=script&lang=js&"
import style0 from "./AiChat.vue?vue&type=style&index=0&id=5d57aa0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d57aa0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/utopia-management/utopia-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d57aa0d')) {
      api.createRecord('5d57aa0d', component.options)
    } else {
      api.reload('5d57aa0d', component.options)
    }
    module.hot.accept("./AiChat.vue?vue&type=template&id=5d57aa0d&scoped=true&", function () {
      api.rerender('5d57aa0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/AiChat.vue"
export default component.exports